// CityAllData.js
import React from 'react';
import { useParams } from 'react-router-dom';
import { BiPlus } from "react-icons/bi";
import { AiOutlineMinus } from "react-icons/ai";
import PhiladelphiaMarketingForm from './PhiladelphiaMarketingForm';
import { Helmet } from "react-helmet";
import NoteFound from '../NoteFound';
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from "react-accessible-accordion";
import { NavLink } from 'react-router-dom';

import cities from "./CityDataObject"

const CityAllData = () => {
    
    const { id } = useParams();

    const city = cities.find(city => city.id === id);

    if (!city) {
        return <div><NoteFound /></div>;
    }

    return (
        <>
            <Helmet>
                <title>{city.title}</title>
                <meta name="description" content={city.metaDiscription} />
                <meta name="keywords" content={city.keywords}></meta>
                <link rel="canonical" href={window.location.origin + window.location.pathname} />
            </Helmet>
            <section className='banner philadelphia_banner'>
                <figure className='banner_figure philadelphia_banner_figure'>
                    <img src='https://ezmarketingtech.s3.amazonaws.com/img/seo_traffic_bg.jpg' width="100%" alt='banner' />
                    <figcaption className='banner_figure_caption philadelphia_banner_figure_caption'>
                        <div className="container">
                            <h1 key={city.id}>{city.bannerHeading}</h1>
                            {city.bannerSubHeading !== "" && <p>{city.bannerSubHeading}</p>}
                        </div>
                    </figcaption>
                </figure>
            </section>
            <section className="drive_traffic_section">
                <div className="container">
                    <h2 className="all_main_heading mb-3">{city.achievingHeading}</h2>
                    <p> {city.achievingSubHeading}</p>
                </div>
            </section>
            <section className="main_reason tailored_services tailored_services">
                <div className="container">
                    <h3>{city.servicesHeading}</h3>
                    <p>{city.servicesSubHeading}</p>
                    <div className="row">
                        {city.serviceBox.map((item) => {
                            return (
                                <div className="col-12 col-sm-12 col-md-6 col-lg-4 mb-5">
                                    <div className="reason_text">
                                        <h4>{item.serboxHead}</h4>
                                        <p>{item.serboxtext}</p>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </section>
            {city.digitalHeading === null ? " " :
                <section className="step_section section_centric">
                    <div className="container">
                        <h3>{city.digitalHeading}</h3>
                        <p className="mb-3">{city.digitalSubHeading}<br /><br /> {city.digitalSubHeading1}</p>
                        {city.digitalHeading === null ? " " : <a className="talk_text" href="/contact-us">{city.listedDigitalLink}</a>}

                    </div>
                </section>}
            {city.listedDigitalData == null ? null :
                <section className="crafted_section bg_dark" >
                    <div className="container">
                        <h3>{city.listedDigitalData[0].head}</h3>
                        <p>{city.listedDigitalData[0].subHead} </p>
                        <ul className="hospitality_list">
                            {city.listedDigitalData[0].listItems.map((data) => {
                                return (
                                    <li>{data}</li>
                                )
                            })}
                        </ul>
                    </div>
                </section>}
            {city.listedDigitalData == null ? null :
                <section className="peek_intro_section" >
                    <div className="container">
                        <h3>{city.listedDigitalData[1].head}</h3>
                        <p>{city.listedDigitalData[1].subHead}</p>
                        <h4>Check out what's in store for you:</h4>
                        <ul className="hospitality_list mb-5">
                            {city.listedDigitalData[1].listItems.map((data) => {
                                return (
                                    <li><NavLink to={`/${data.linkUrl}`}>{data.linkText}</NavLink></li>

                                )
                            })}
                        </ul>
                        <p>{city.listedDigitalData[1].belowData}</p>
                        <h2>{city.listedDigitalData[1].belowHead}</h2>
                        <p>{city.listedDigitalData[1].subBelowHead}</p>
                        <p>{city.listedDigitalData[1].subBelowHead1}</p>
                        <p>{city.listedDigitalData[1].subBelowHead2}</p>
                    </div>
                </section>}


            <section className="seo_faq_section philadelphia_faq_section">
                <div className="container">
                    <h3>FAQs</h3>
                    <h3>{city.mainHeading}</h3>
                    <div className="seo_tabs_wrapper">
                        <Accordion preExpanded={["a"]}>
                            {city.citiesFaq.map((item) => {
                                return (
                                    <AccordionItem uuid={item.uId}>
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                                <h3>
                                                    <BiPlus className=" auto_show" />
                                                    <AiOutlineMinus className=" after_show" />
                                                    {item.FaqHeading1}
                                                </h3>
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                            <p>{item.FaqHeadingAns1} </p>
                                        </AccordionItemPanel>
                                    </AccordionItem>
                                )
                            })}
                        </Accordion>
                    </div>
                </div>
            </section>
            <PhiladelphiaMarketingForm cityName={city.formTitle} />
        </>
    );
};

export default CityAllData;